import React, { FC, useMemo } from 'react';
import styles from './index.module.scss';
import { CallOffsSubCategory, OverviewQp, ProcurementsDisplay } from 'src/models/procurements/types';
import classNames from 'classnames';
import { useGetNewOverviewUrl } from 'src/models/procurements/hooks';
import { Link } from 'react-router-dom';
import { IBaseInbox } from 'src/models/callOffs/types';
import { useBaseInfoOfActiveInbox } from 'src/models/callOffs/hooks';
import { Tooltip } from 'src/common';
import useOverviewMode from 'src/reactiveVars/overviewModeVar';
import { isCallOffSubCategory } from 'src/models/procurements/helpers';
import { useQueryParams } from 'src/helpers/history';

interface IProps {
  inbox: IBaseInbox;
  sidebarIsOpen?: boolean;
}

export const InboxesItem: FC<IProps> = props => {
  const { inbox, sidebarIsOpen } = props;
  const qp = useQueryParams();
  const currentSubCategory = qp[OverviewQp.SubCategory];
  const callOffSubCategory = isCallOffSubCategory(currentSubCategory) ? currentSubCategory : CallOffsSubCategory.NEW;

  const procurementTabInfo = useOverviewMode();

  const { emailAddress: inboxId, inboxName, color } = inbox;

  const currentInbox = useBaseInfoOfActiveInbox();

  const getLinkOverview = useGetNewOverviewUrl();
  const linkToInbox = useMemo(() => {
    return getLinkOverview({ [OverviewQp.Inbox]: inboxId, [OverviewQp.SubCategory]: callOffSubCategory });
  }, [getLinkOverview, inboxId, callOffSubCategory]);

  return (
    <Link
      className={classNames(
        styles.menuItem,
        {
          [styles.isActive]:
            currentInbox &&
            currentInbox.emailAddress === inboxId &&
            procurementTabInfo &&
            procurementTabInfo.tab === ProcurementsDisplay.CALL_OFFS
        },
        { [styles.isClosed]: !sidebarIsOpen }
      )}
      tabIndex={0}
      to={linkToInbox}
    >
      <Tooltip
        title={inboxName ?? inboxId}
        placement={'right'}
        className={classNames(styles.tooltip, { [styles.isIconOnly]: !sidebarIsOpen })}
      >
        <span className={styles.itemBadge} style={{ color: color }}></span>
        {sidebarIsOpen && <span className={styles.itemLabel}>{inboxName ?? inboxId}</span>}
      </Tooltip>
    </Link>
  );
};

export default InboxesItem;
